/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Taganalysis1Inputs */

const zh_showcase_taganalysis1 = /** @type {(inputs: Showcase_Taganalysis1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能赏析`)
};

const en_showcase_taganalysis1 = /** @type {(inputs: Showcase_Taganalysis1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Analysis`)
};

const es_showcase_taganalysis1 = /** @type {(inputs: Showcase_Taganalysis1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis Inteligente`)
};

/**
* | output |
* | --- |
* | "Smart Analysis" |
*
* @param {Showcase_Taganalysis1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_taganalysis1 = /** @type {((inputs?: Showcase_Taganalysis1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Taganalysis1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_taganalysis1(inputs)
	if (locale === "en") return en_showcase_taganalysis1(inputs)
	return es_showcase_taganalysis1(inputs)
});
export { showcase_taganalysis1 as "showcase_tagAnalysis" }